// Empty stub for Node.js built-in modules (dns, tls, net, fs) when bundled for the browser.
// ioredis references these modules but the code paths that use them never execute client-side.
module.exports = {};
